import { createFileRoute } from '@tanstack/react-router';
import RoomsPage from '../../../../pages/RoomsPage';

export const Route = createFileRoute('/_authenticated/$owner/rooms/')({
  component: RoomsPage
});
